<template>
  <div class="analytics">
    <div class="page-header">
      <h1>Analytics</h1>
      <p>Advanced analytics and insights</p>
    </div>
    
    <el-card class="coming-soon">
      <div class="coming-soon-content">
        <el-icon><TrendCharts /></el-icon>
        <h2>Coming Soon</h2>
        <p>Advanced analytics feature is under development</p>
      </div>
    </el-card>
  </div>
</template>

<script>
import { TrendCharts } from '@element-plus/icons-vue'

export default {
  name: 'Analytics',
  components: { TrendCharts }
}
</script>

<style scoped>
.analytics {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h1 {
  margin: 0 0 8px 0;
  font-size: 1.8rem;
  font-weight: 600;
  color: #2c3e50;
}

.page-header p {
  margin: 0;
  color: #7f8c8d;
}

.coming-soon {
  border-radius: 8px;
}

.coming-soon-content {
  text-align: center;
  padding: 60px 20px;
  color: #7f8c8d;
}

.coming-soon-content .el-icon {
  font-size: 4rem;
  margin-bottom: 20px;
  color: #c0c4cc;
}

.coming-soon-content h2 {
  margin: 0 0 10px 0;
  font-size: 1.5rem;
  color: #2c3e50;
}

.coming-soon-content p {
  margin: 0;
  color: #7f8c8d;
}
</style> 